import { forwardRef } from "react";
import { Input } from "@/components/ui/input";

// Máscara de centavos no padrão brasileiro: digitar 3800 mostra 38,00.
const show = (v) => {
  const d = String(v ?? "").replace(/\D/g, "").replace(/^0+/, "").slice(0, 11);
  return d ? (Number(d) / 100).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "";
};
export const parseMoney = (v) => Number(String(v ?? "").replace(/\./g, "").replace(",", ".")) || 0;
const toEnd = (el) => requestAnimationFrame(() => { const n = el.value.length; el.setSelectionRange(n, n); });

export const MoneyInput = forwardRef(function MoneyInput({ value, onChange, onFocus, ...rest }, ref) {
  return (
    <Input ref={ref} type="text" inputMode="numeric" autoComplete="off" value={show(value)} {...rest}
      onFocus={(e) => { toEnd(e.target); onFocus?.(e); }}
      onChange={(e) => { onChange(show(e.target.value)); toEnd(e.target); }} />
  );
});
